<h3 class="ff-title-xs ff-bold mt-16 mb-16">
  {{ 'nonConformita.title' | translate }}
</h3>
<div *ngIf="nonConformitaPresenti; else noNonConformitaBlock">
  <ds-table
    *ngIf="tableConfig"
    [tableConfig]="tableConfig"
    (onClickRightAction)="onClickRightAction($event)"
    (onClickSecondRightAction)="onClickSecondRightAction($event)">
  </ds-table>
</div>

<ds-overlay-fullscreen
  *ngIf="showOverlay"
  (closeModal)="closeModal($event)"
  [attr.has-padding]="true"
  [attr.is-title-centered]="true">
  <div slot="title">
    <h2
      class="  ff-title-s ff-bold"
      style="margin: 0"
      id="overlay-title">
      {{ overlayTitle }}
    </h2>
  </div>
  <div
    slot="text"
    style="
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    ">
    <div
      class="  ff-body-l ff-regular"
      style="color: var(--text-placeholder); overflow-y: auto"
      id="overlay-description">
      <ng-container *ngIf="overlayTableConfig.tableRows?.length > 0; else noElementBlock">
        <ds-table
          [tableConfig]="overlayTableConfig"
          [attr.table-empty-title]="'emptyTableTitle' | translate"
          [attr.table-empty-description]="'emptyTableDescription' | translate"
          [attr.table-empty-image-url]="emptyImage"
          [attr.table-empty-image-alt]="'emptyTableAltImage' | translate">
        </ds-table>
      </ng-container>
      <ng-template #noElementBlock>
        <app-no-element></app-no-element>
      </ng-template>
    </div>
  </div>
</ds-overlay-fullscreen>

<ng-template #noNonConformitaBlock>
  <div>
    <app-no-element></app-no-element>
  </div>
</ng-template>

<ds-spinner
  *ngIf="!downloadNonConformitaComplete || !checkPaginator"
  [attr.spinner-ui-variant]="'spinner'"
  [attr.spinner-aria-label]="'Caricamento' | translate"></ds-spinner>
